import React, { useEffect, useState } from "react";

// Singpass Redirect URL landing (Phase 1). Public route — Singpass redirects the
// browser here after authentication. It safely acknowledges the return and reads
// code/state without exchanging anything (token exchange is Phase 2). Query values
// are attacker-controlled, so `state` is validated and `code` is never rendered.
const SAFE_STATE = /^[A-Za-z0-9/+_\-=.]{1,255}$/;

export default function SingpassCallback() {
  const [status, setStatus] = useState({ tone: "neutral", title: "Completing sign-in…", detail: "Please wait while we acknowledge your Singpass return." });

  useEffect(() => {
    const p = new URLSearchParams(window.location.search);
    const code = p.get("code");
    const state = p.get("state");
    const error = p.get("error");
    if (state && !SAFE_STATE.test(state)) {
      setStatus({ tone: "error", title: "Invalid request", detail: "The sign-in parameters could not be verified. Please start again." });
      return;
    }
    if (error) {
      setStatus({ tone: "error", title: "Sign-in not completed", detail: "Singpass reported an authentication error. No data was exchanged — you can safely try again." });
      return;
    }
    if (code) {
      setStatus({ tone: "ok", title: "Callback received", detail: "Your Singpass return was received successfully. Secure sign-in is being finalised — this feature is being rolled out." });
      return;
    }
    setStatus({ tone: "neutral", title: "Singpass sign-in", detail: "This page completes your Singpass return. Open it from a Singpass sign-in to continue." });
  }, []);

  const dot = status.tone === "ok" ? "bg-[#00E65B]" : status.tone === "error" ? "bg-red-400" : "bg-[#FFB800]";

  return (
    <div className="min-h-screen w-screen flex items-center justify-center bg-background px-6" data-testid="singpass-callback-page">
      <div className="card-flat p-8 max-w-md w-full text-center space-y-4">
        <div className="mx-auto h-12 w-12 rounded-full bg-surface border border-border grid place-items-center">
          <span className={`h-3 w-3 rounded-full ${dot} ${status.tone === "neutral" ? "animate-pulse" : ""}`} />
        </div>
        <h1 className="font-display text-xl font-bold tracking-tight" data-testid="singpass-callback-title">{status.title}</h1>
        <p className="text-sm text-muted-foreground" data-testid="singpass-callback-detail">{status.detail}</p>
        <div className="text-[11px] text-muted-foreground/70 font-mono pt-2 border-t border-border">Singpass · MyInfo Business</div>
      </div>
    </div>
  );
}
